import type { SessionRecord } from './types'

/** The workflow variant recorded by Nebula when the session was created. */
export function getSessionVariant(
  metadata: SessionRecord['metadata']
): string | null {
  const variant = metadata?.variant_key
  return typeof variant === 'string' && variant.length > 0 ? variant : null
}
